
import React from "react";
import Withdrawal from "./Withdrawal";
import Transactions from "./Transactions";
import { IMember } from "../../../services";
import ManageEarnings from "./ManageEarnings";
import CurrencyEarning from "./CurrencyEarning";
import * as ReactRouterDom from "react-router-dom";

export interface EarningsProps {
    profile: IMember;
}

function Earnings(props: EarningsProps) {

    const { profile } = props;

    return (<ReactRouterDom.Routes>
        <ReactRouterDom.Route path="/" element={<ManageEarnings profile={profile} />} />
        <ReactRouterDom.Route path="/:currency" element={<CurrencyEarning profile={profile} />} />
        <ReactRouterDom.Route path="/transactions" element={<Transactions profile={profile} />} />
        <ReactRouterDom.Route path="/:currency/withdrawal" element={<Withdrawal profile={profile} />} />
    </ReactRouterDom.Routes>);

}

export default Earnings;
